import React from 'react';

const TabsContext = React.createContext({
  activeTab: '',
  setActiveTab: {} as React.Dispatch<string>,
});
export default TabsContext;
